/**
 * 按需加载 jQuery（控制台 Bootstrap / 遗留 $ 调用仍依赖）
 * 官网 site2026 前台不引入，避免首页体积浪费
 */
let loading = null

export function ensureJquery() {
  if (typeof window.jQuery !== 'undefined') {
    return Promise.resolve(window.jQuery)
  }
  if (loading) {
    return loading
  }
  loading = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = `${process.env.BASE_URL}js/jquery.min.js`
    script.async = true
    script.onload = () => {
      if (typeof window.jQuery === 'undefined') {
        reject(new Error('jQuery loaded but window.jQuery is missing'))
        return
      }
      window.$ = window.jQuery
      resolve(window.jQuery)
    }
    script.onerror = () => {
      loading = null
      reject(new Error('Failed to load jQuery'))
    }
    document.head.appendChild(script)
  })
  return loading
}

/** 加载 jQuery 后再加载依赖它的 Bootstrap JS */
export function ensureJqueryAndBootstrap() {
  return ensureJquery().then(() => import('@/utils/bootstrap.min.js'))
}
